export type ChatScrollTarget = {
  scrollHeight: number;
  scrollTop: number;
  clientHeight?: number;
};

export function scrollChatToLatest(target: ChatScrollTarget): void {
  target.scrollTop = target.scrollHeight;
}

export function isChatNearLatest(target: Required<ChatScrollTarget>, threshold = 56): boolean {
  return target.scrollHeight - target.scrollTop - target.clientHeight <= threshold;
}

export type ChatPrependAnchor = {
  scrollHeight: number;
  scrollTop: number;
};

export function restoreChatAfterPrepend(target: ChatScrollTarget, anchor: ChatPrependAnchor): void {
  target.scrollTop = anchor.scrollTop + Math.max(0, target.scrollHeight - anchor.scrollHeight);
}
